import React from 'react';
import '../Styles/InternshipProgram.css'; 
import AppHeader from '../Layout/Header';
import FooterComponent from '../Layout/Footer';
import IntroductionComponent from '../Components/Internship Component/InternIntro';
import LegacySection from '../Components/Internship Component/LegacySection';

const facebookPage = 'https://www.facebook.com/ncgsa.ist/';
const facebookEmbed = `https://www.facebook.com/plugins/page.php?href=${encodeURIComponent(facebookPage)}&tabs=timeline&width=500&height=620&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true`;

const InternshipProgram = () => {
  return (
    <>
    <AppHeader/>
      <div className="internship-container">
        {/* Background Section */}
        <div className="internship-bg"></div>

      <main className="page-content-bands">
        <section><IntroductionComponent/></section>
        <section className="internship-2026-section" aria-labelledby="internship-2026-title">
          <div className="internship-2026-inner">
            <div className="internship-2026-top">
              <header>
                <p className="section-eyebrow">SUMMER INTERNSHIP</p>
                <h2 id="internship-2026-title">Internship Program 2026</h2>
                <div className="internship-title-line" aria-hidden="true" />
                <p>
                  The National Center of GIS &amp; Space Applications (NCGSA), Institute of Space
                  Technology, Islamabad, invites applications for the NCGSA Summer Internship Program
                  2026. This program is designed for motivated college and university students who are
                  interested in gaining hands-on exposure to space science, space technology,
                  geospatial applications, and research-based project development. The internship
                  provides students with an opportunity to work in a professional academic and
                  research environment under the supervision of experienced faculty members,
                  researchers, and domain experts.
                </p>
                <p>
                  Through this internship, participants will engage in practical tasks,
                  domain-specific assignments, project-based learning, technical discussions, and
                  report preparation. The program aims to strengthen students’ technical
                  understanding, research skills, problem-solving ability, and professional confidence
                  in the field of space science and its applications.
                </p>
              </header>
              <figure className="internship-2026-poster">
                <img
                  src="https://ncgsa.org.pk/wp-content/uploads/2026/06/Internship-flyer-2026.jpg-800x800.jpeg"
                  alt="NCGSA Summer Internship Program 2026 poster"
                  loading="lazy"
                />
              </figure>
            </div>
            <figure className="internship-2026-domains">
              <img
                src="https://ncgsa.org.pk/wp-content/uploads/2026/06/INTERNSHIP-DOMAINS-new-June-17-01-scaled.jpg"
                alt="NCGSA Summer Internship Program 2026 domains"
                loading="lazy"
              />
            </figure>
          </div>
        </section>
        <section><LegacySection/></section>
        <section className="internship-facebook-section" aria-labelledby="internship-facebook-title">
          <div className="internship-facebook-inner">
            <header className="internship-facebook-header">
              <p className="section-eyebrow">STAY CONNECTED</p>
              <h2 id="internship-facebook-title">Social Feed</h2>
              <div className="internship-title-line" aria-hidden="true" />
            </header>
            <div className="internship-facebook-wrap">
              <iframe
                title="NCGSA Facebook feed"
                src={facebookEmbed}
                width="500"
                height="620"
                scrolling="no"
                frameBorder="0"
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                loading="lazy"
              />
            </div>
            <a href={facebookPage} target="_blank" rel="noopener noreferrer" className="internship-facebook-link">
              View NCGSA on Facebook <span aria-hidden="true">→</span>
            </a>
          </div>
        </section>
      </main>

      </div>
      <FooterComponent/>
    </>
  );
};

export default InternshipProgram;
